import type { AutobuildOutcome } from "@a7y/types";
import { OUTCOME_STYLES } from "./shared";

export function OutcomeBadge({ outcome }: { outcome: AutobuildOutcome }) {
  const s = OUTCOME_STYLES[outcome];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium ${s.badge}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}
